export const TEMA_ROUTE_IDS = {
  DASHBOARD: "dashboard",
  TEACH_PREPARE: "teach-prepare",
  CREATE_QUESTIONS: "create-questions",
  BUILD_ASSESSMENTS: "build-assessments",
  ASSIGN_ENRICHMENT: "assign-enrichment",
  QUICK_SHEETS: "quick-sheets",
  CONCEPT_QUESTIONS: "concept-questions",
  QUESTION_VARIATIONS: "question-variations",
  QUICK_ASSESSMENT: "quick-assessment",
  TEACH_THIS_TOPIC: "teach-this-topic",
  EXPLAIN_DIFFERENTLY: "explain-differently",
  CONTENT_SIMPLIFIER: "content-simplifier",
  QUESTION_PAPER: "question-paper",
  SECTION_BUILDER: "section-builder",
  DIFFICULTY_BALANCER: "difficulty-balancer",
  DOUBT_SOLVER: "doubt-solver",
  SLIDE_DECK_GENERATOR: "slide-deck-generator",
  PROJECT_BUILDER: "project-builder",
  ACTIVITY_GENERATOR: "activity-generator",
  REAL_WORLD_TASK: "real-world-task",
  LIBRARY: "library",
  NOT_FOUND: "not-found",
};

export const TEMA_ROUTE_PATHS = {
  DASHBOARD: "#",
  TEACH_PREPARE: "#teach-prepare",
  CREATE_QUESTIONS: "#create-questions",
  BUILD_ASSESSMENTS: "#build-assessments",
  ASSIGN_ENRICHMENT: "#assign-enrichment",
  QUICK_SHEETS: "#quick-sheets",
  CONCEPT_QUESTIONS: "#concept-questions",
  QUESTION_VARIATIONS: "#question-variations",
  QUICK_ASSESSMENT: "#quick-assessment",
  TEACH_THIS_TOPIC: "#teach-this-topic",
  EXPLAIN_DIFFERENTLY: "#explain-differently",
  CONTENT_SIMPLIFIER: "#content-simplifier",
  QUESTION_PAPER: "#question-paper-generator",
  SECTION_BUILDER: "#section-builder",
  DIFFICULTY_BALANCER: "#difficulty-balancer",
  DOUBT_SOLVER: "#doubt-solver",
  SLIDE_DECK_GENERATOR: "#slide-deck-generator",
  PROJECT_BUILDER: "#project-builder",
  ACTIVITY_GENERATOR: "#activity-generator",
  REAL_WORLD_TASK: "#real-world-task",
  LIBRARY: "#library",
};

export const TEMA_PERMISSIONS = {
  WORKSPACE_ACCESS: "tema:workspace:access",
  TOOLS_GENERATE: "tema:tools:generate",
};

export const TEMA_ROLES = {
  TEACHER: "teacher",
};

export const DEFAULT_TEACHER_PERMISSIONS = [
  TEMA_PERMISSIONS.WORKSPACE_ACCESS,
  TEMA_PERMISSIONS.TOOLS_GENERATE,
];
